"use client";

import { useEffect, useState } from 'react';
import { useInView as useSpringInView, IntersectionArgs } from "@react-spring/web";

// fix useInView default true;
export const useInView = (args?:IntersectionArgs) => {
     const  [isIn, setIsIn] = useState(true);
     const [ref,isInView] = useSpringInView(args);
     
     useEffect(() => {
          if(ref.current) {
            setIsIn(isInView);
          }
     }, [isInView]);

     return [ref,isIn];
};